import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';

@Component({
    selector: 'app-report-detailed',
    templateUrl: './report-detailed.component.html',
    styleUrls: ['./report-detailed.component.scss'],
    standalone: false
})
export class ReportDetailedComponent implements OnInit {
  states: any;
  @ViewChild('calendar') calendar: any;
  visibleSidebar:boolean = false;
  selectedState:any;
  rangeDates: Date[] =[];
  selectedDate: any;
  summaryReportData:any =[];
  showTotalOrder :boolean = false;
  displayBranch! : any ;
  currentData = new Date();
  constructor(private storageService:StorageService,private router: Router, private exportExcelService:ExportExcelService,private userDashboardService:UserDashboardService,private cookieService: CookieService) { 
   
    this.userDashboardService.getBranchList().subscribe((res:any)=>{
   
      this.states = res['content'];
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
     
  })
 
 
  }

  ngOnInit(): void {
  }

  gotoDashboard(){
    this.router.navigate(['doqfy/dashboard']);
  }

  onSelect(){
    if (this.rangeDates[1]) { 
      this.calendar.overlayVisible=false;
  }
}

  export(){
    this.exportExcelService.convertToExcel(this.states,'sample');
  }

  getSelected(){
    this.cookieService.set('BranchName', this.selectedState);
  this.storageService.setBranch(this.selectedState)
  }
  }



